var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showSideNavigation)?_c('build-nav'):_vm._e(),_c('top-nav-bar'),_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }